export const DECLARATION = 'Declaration'
export const EXPRESSION = 'Expression'
export const KEYWORD = 'Keyword'
export const OPERATOR = 'Operator'
export const STATEMENT = 'Statement'
